import { Box, Typography } from "@mui/material"
import { useContextState } from "../../../../../../../hooks/theme"
import { useStyles } from "./styles"


export const MapPointDestination = ({ name }: { name:string }) => {

    const { colors } = useContextState()
    const styles = useStyles()
    const colorPoint = colors.color16


    return (
        <Box sx={styles.container}>
            <Box sx={styles.mark}>
                <Typography sx={styles.header(colorPoint)}>{name}</Typography>
                <Box sx={styles.containerMark}>
                    <svg width="50" height="62" viewBox="0 0 50 70" xmlns="http://www.w3.org/2000/svg">
                        {/* <!-- Pin base --> */}
                        <path d="M25 0
                            C11.2 0 0 11.2 0 25
                            C0 39.6 25 70 25 70
                            C25 70 50 39.6 50 25
                            C50 11.2 38.8 0 25 0Z"
                            fill={colorPoint}
                        />

                        {/* <!-- Círculo blanco central --> */}
                        <circle cx="25" cy="25" r="17" fill="white" />

                        {/* <!-- Texto en el centro --> */}
                        {/* <text x="25" y="30" font-size="12" text-anchor="middle" fill="black" font-weight="bold">{'X'}</text> */}
                    </svg>
                </Box>
            </Box>
        </Box>
    )
}